export const currencySymbol = (currency: string): string => {
  try {
    const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' });
    const parts = formatter.formatToParts(0);
    const symbol = parts.find(part => part.type === 'currency')?.value;
    return symbol || '$';
  } catch {
    return '$';
  }
};